import React, { Fragment, useState, useEffect, useRef } from 'react';
import { ToastProvider, useToasts } from 'react-toast-notifications';
import { Container, Row, Col, FormGroup,ButtonGroup } from 'react-bootstrap';
import Card from 'components/Card/Card.jsx';
import Button from '../../components/CustomButton/CustomButton';
import language from '../../config/es';
import AsyncSelect from 'react-select/async';
import DataTable from 'react-data-table-component';
import app from '../../config/application';
//redux
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import { findData, getCountData, sendPayment } from '../../redux/monitor.duck';
import LabelChargeData from '../../components/Label/labelChargeData';
import Select from 'react-select';
import { findSocieties } from '../../redux/society.duck';
//Session user
import SessionConfig from '../../config/session_config';
import PaymentDetailTable, {
  getDetailStatusClassName as getStatusClassName,
} from './PaymentDetailTable';
import DateRangeFilter from './shared/DateRangeFilter';
import { createIncomeFilterHandlers } from './shared/incomeFilterHandlers';
import { getServerTableProps } from './shared/serverTableProps';
import {
  buildTraceColumn,
  buildEntityColumn,
  buildClientColumn,
  buildChannelColumn,
  buildTotalColumn,
  buildStateColumn,
  buildDateColumn,
} from './shared/incomeColumns';

const ExpandedComponent = ({ data }) => (
  <PaymentDetailTable
    data={data}
    textSizeClass="small"
    amountWidth="100px"
    formatAmount={(amount) => amount.toFixed(4)}
  />
);

// Columnas de la tabla de pagos a enviar
const buildSendIncomeColumns = (options, optionsTime) => [
  buildTraceColumn(() => 'text-primary text-uppercase '),
  buildEntityColumn(
    '200px',
    'text-uppercase small-font',
    ' text-uppercase small-font badge bg-secondary '
  ),
  buildClientColumn('260px', ' text-uppercase small-font'),
  buildChannelColumn(' text-uppercase small-font'),
  buildTotalColumn('140px', () => 'text-primary ', 4),
  buildStateColumn(getStatusClassName),
  buildDateColumn(options, optionsTime),
];

const SendIncome = () => {
  const ref = useRef();
  const { addToast } = useToasts();
  const dispatch = useAppDispatch();
  const [date, setDate] = useState({
    dateIni: new Date(),
    dateEnd: new Date(),
    dateFIni: new Date(),
    dateFEnd: new Date(),
  });
  const [enable, setEnable] = useState(true);
  const [data, setData] = useState({
    salesArea: [],
    payments: [],
    columns: [],
    selectedRows: [],
    societies: [],
    showloadingSociety: false,
    pendingData: false,
    page: 0,
    size: 10,
    totalRows: 0,
    options: { year: 'numeric', month: 'numeric', day: 'numeric' },
    optionsTime: { hour: 'numeric', minute: 'numeric' },
    showSelection: false,
    filterCodeClient: '',
    client: { value: 0, label: '' },
    society: { value: 0, label: '' },
    state: {
      value: app.data.typeCode.inProgress,
      label: language.messages.lblAll,
    },
    auth: JSON.parse(sessionStorage.getItem('user')),
    error: '',
  });
  data.payments = useSelector((store) => store.monitorReducer.monitorData);
  data.totalRows = useSelector((store) => store.monitorReducer.totalRows);
  data.clients = useSelector((store) => store.clientReducer.clients);
  data.societies = useSelector((store) => store.societyReducer.societies);
  data.error = useSelector((store) => store.monitorReducer.noPermittedMonitor);
  const {
    refreshState,
    updateState,
    viewNotification,
    messageError,
    changeClient,
    handlePerRowsChange,
    handlePageChange,
    onChangeDate,
    onChangeDateEnd,
    promiseOptions,
  } = createIncomeFilterHandlers({
    data,
    setData,
    date,
    setDate,
    dispatch,
    addToast,
    search: () => search(),
  });

  //ciclo de vida ---------------------------------------------------
  useEffect(() => {
    messageError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.error]);
  useEffect(() => {
    void loadSocieties();
    initTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    ref.current.onRefreshCurrentSession();
  }, [data]);
  //handlers ---------------------------------------------------
  const handleSelectRow = (state) => {
    updateState(state.selectedRows, 'selectedRows');
  };
  const loadSocieties = async () => {
    await dispatch(findSocieties(data.auth.id.user.userId));
    data.showloadingSociety = true;
    updateState(true, 'showloadingSociety');
  };

  //funciones ---------------------------------------------------
  const search = async () => {
    if (data.society.value === 0) {
      viewNotification(language.messages.msmSociety, 'error');
    } else {
      data.pendingData = true;
      setEnable(false);
      date.dateFIni = date.dateIni;
      date.dateFEnd = date.dateEnd;
      data.filterCodeClient = data.client.value;
      refreshState();
      await loadCount();
      await loadData();
    }
  };
  const initStateSend = (value) => {
    setEnable(value);
    updateState(value, 'showSelection');
    updateState(!value, 'pendingData');
  };
  const sendData = async () => {
    if (data.selectedRows.length > 0) {
      let lsData = [];
      data.selectedRows.forEach((element) => {
        let item = { Id: 0 };
        item.Id = element.paymentId;
        lsData.push(item);
      });
      initStateSend(false);
      let response = await dispatch(sendPayment(lsData));

      data.showSelection = true;
      if (response.code !== undefined) {
        viewNotification(response.message, 'error');
      } else {
        viewNotification(language.messages.msmSendPayments, 'success');
        await search();
      }
      initStateSend(true);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const contextActions = React.useMemo(() => {
    return (
      <Button
        key="delete"
        primary
        fill
        type="button"
        disabled={!enable}
        onClick={sendData}
      >
        {' '}
        <i className="fa fa-save"></i>
        {language.messages.monitor.send}
      </Button>
    );
  });
  // Filtro de busqueda de pagos
  const buildFilterJson = (page) => ({
    user_id: data.auth.id.user.userId,
    dateStart: date.dateFIni,
    dateEnd: date.dateFEnd,
    statusPayment: 0,
    statusPaymentCode: data.state.value,
    documentOrCodeClient: data.filterCodeClient,
    quantity: data.size,
    page,
    societyCode: data.society.value,
    entity: 0,
  });
  const loadData = async () => {
    let json = buildFilterJson(data.page);
    await dispatch(findData(json, data.auth.id.user.username));
    data.pendingData = false;
    setEnable(true);
    refreshState();
  };
  const loadCount = async () => {
    let json = buildFilterJson(0);
    await dispatch(getCountData(json, data.auth.id.user.username));
  };
  const updateSelect = (value, id) => {
    if (id === 'society') {
      data.society = value;
    }
    refreshState();
  };
  const initTable = () => {
    data.columns = buildSendIncomeColumns(data.options, data.optionsTime);
    updateState(data.columns, 'columns');
  };

  //render----------------------------------------------------------
  return (
    <Fragment>
      <SessionConfig ref={ref} />
      <div className="main-content">
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <Card
                icono=" fa  fa-filter"
                title={language.messages.title_filter}
                content={
                  <Fragment>
                    <Row>
                      <DateRangeFilter
                        onChangeDate={onChangeDate}
                        onChangeDateEnd={onChangeDateEnd}
                      />

                      <Col sm={4} lg={4} xl={2}>
                        <h6 className="title">
                          {language.messages.society.title_society}
                        </h6>
                        <LabelChargeData
                          showloading={data.showloadingSociety}
                        />
                        <FormGroup>
                          <Select classNamePrefix="ui-select"
                            placeholder={language.messages.lblSingleSelect}
                            name="society"
                            options={data.societies}
                            className="text-uppercase small"
                            value={{
                              value: data.society.value,
                              label: data.society.label,
                            }}
                            onChange={(value) => {
                              updateSelect(value, 'society');
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={6} lg={6} xl={3}>
                        <h6 className="title">
                          {language.messages.monitor.lblClient}
                        </h6>
                        <AsyncSelect classNamePrefix="ui-select"
                        maxMenuHeight={150}
                          cacheOptions
                          className="small text-uppercase"
                          isDisabled={data.society.value === 0}
                          placeholder={language.messages.lblSingleSelect}
                          name="client"
                          loadOptions={promiseOptions}
                          isClearable={true}
                          value={{
                            value: data.client.value,
                            label: data.client.label,
                          }}
                          onChange={(value) => {
                            changeClient(value);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={5} lg={5} xl={3}>
                      <ButtonGroup >
                        <Button
                          disabled={!enable}
                          info
                          fill
                          font_small
                          type="button"
                          onClick={search}
                        >
                          <i className="fa fa-search"></i>{' '}
                          {language.messages.monitor.lblSearch}
                        </Button>
                        </ButtonGroup>
                      </Col>
                    </Row>
                    <hr />
                    <div className="fresh-datatables">
                      <DataTable
                        selectableRows
                        onSelectedRowsChange={handleSelectRow}
                        clearSelectedRows={data.showSelection}
                        contextActions={contextActions}
                        title={language.messages.sendPayments.title_monitor}
                        data={data.payments}
                        columns={data.columns}
                        {...getServerTableProps({
                          data,
                          scrollHeight: '600px',
                          onChangeRowsPerPage: handlePerRowsChange,
                          onChangePage: handlePageChange,
                        })}
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                      />
                    </div>
                  </Fragment>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

const App = () => (
  <ToastProvider>
    <SendIncome />
  </ToastProvider>
);
export default App;
